import React from "react";

const leaders = [
  {
    name: "Elena Park",
    role: "CEO, Co-founder",
    image: "https://i.pravatar.cc/300?img=1",
    tags: ["Ex-HSBC", "CFA"],
  },
  {
    name: "Marcus Nguyen",
    role: "CTO, Co-founder",
    image: "https://i.pravatar.cc/300?img=2",
    tags: ["Ex-Stripe", "Security"],
  },
  {
    name: "Priya Desai",
    role: "Head of Risk",
    image: "https://i.pravatar.cc/300?img=3",
    tags: ["Credit", "Analytics"],
  },
  {
    name: "Daniel Romero",
    role: "COO",
    image: "https://i.pravatar.cc/300?img=4",
    tags: ["Ops", "Partnerships"],
  },
];

const Leadership = () => {
  return (
    <section className="py-16 bg-white border-t-2 border-[#f4f4f4]">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-semibold text-gray-900 mb-8">
          Leadership
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {leaders.map((leader, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-xl p-4 bg-white text-center"
            >
              <img
                src={leader.image}
                alt={leader.name}
                className="w-full h-52 object-cover rounded-lg mb-4"
              />

              <h4 className="font-semibold text-gray-900">{leader.name}</h4>
              <p className="text-sm text-gray-500 mb-3">{leader.role}</p>

              <div className="flex flex-wrap justify-center gap-2">
                {leader.tags.map((tag, i) => (
                  <span
                    key={i}
                    className="text-xs px-3 py-1 bg-[#E6F8F3] text-[#2CC7A3] rounded-full"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Leadership;
